module.exports = __webpack_public_path__ + "img/engine-hour.cc8bd65e.svg";